import axios from 'axios'
import config from '@/config'

const actions = {
  GET_ADDRESS_ROW({rootGetters}, addressId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.ADDRESS_SERVICE_APi_URL + 'address/row/?addressId=' + addressId,
          rootGetters.getRequestConfig
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_ADDRESS_DETAILS({rootGetters}, addressId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.ADDRESS_SERVICE_APi_URL + 'address/?addressId=' + addressId,
          rootGetters.getRequestConfig
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_STREET_ROW({rootGetters}, streetId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.ADDRESS_SERVICE_APi_URL + 'address/street/row/?streetId=' + streetId,
          rootGetters.getRequestConfig
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_STREETS({rootGetters}) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ADDRESS_SERVICE_APi_URL + 'address/street/?str=', rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_STREET_BUILDINGS({rootGetters}, streetId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.ADDRESS_SERVICE_APi_URL + 'address/house/?streetId=' + streetId,
          rootGetters.getRequestConfig
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_BUILDING_APARTMENTS({rootGetters}, address) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.ADDRESS_SERVICE_APi_URL +
            'address/apartment/?streetId=' +
            address.streetId +
            '&building=' +
            address.building,
          rootGetters.getRequestConfig
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
